import { validateInputs } from 'shared/lib';
import { SignUpPointErrors } from 'shared/consts/sign-up-point.error';

interface IValidateForm {
  name: string;
  address: string;
  phone: string;
}

export const validateCreatePointForm = ({
  name,
  address,
  phone,
}: IValidateForm) => {
  if (!validateInputs.validateBusinessName(name)) {
    return SignUpPointErrors.INCORRECT_NAME;
  }
  if (!validateInputs.validateBusinessAddress(address)) {
    return SignUpPointErrors.INCORRECT_ADDRESS;
  }
  if (!validateInputs.validatePhone(phone)) {
    return SignUpPointErrors.INCORRECT_PHONE;
  }
  return false;
};
